import { render, staticRenderFns } from "./hh2.vue?vue&type=template&id=6cbe5142&scoped=true"
import script from "./hh2.vue?vue&type=script&lang=js"
export * from "./hh2.vue?vue&type=script&lang=js"
import style0 from "./hh2.vue?vue&type=style&index=0&id=6cbe5142&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbe5142",
  null
  
)

export default component.exports